export interface GetTransitionOptions {
    duration?: number;
    animationDelay?: number;
    animationCurve?: string;
}

export const ANIMATION_DELAY = {
    default: 0,
};

export const ANIMATION_DURATION = {
    default: 350,
    fast: 200,

    // TODO remove & replace this values once are available in design tokens package
    duration10: 120,
    duration20: 160,
    duration30: 300,
    duration40: 400,
    duration50: 500,
    duration60: 700,
    duration70: 1000,
    duration80: 1500,
    duration90: 2000,
};

export const ANIMATION_CURVE = {
    fastOutLinearIn: 'cubic-bezier(.4, 0, 1, 1)',
    fastOutSlowIn: 'cubic-bezier(.4, 0, .2, 1)',
    linearOutSlowIn: 'cubic-bezier(0, 0, .2, 1)',

    // TODO remove & replace this values once are available in design tokens package
    easeIn: 'cubic-bezier(0.56, 0, 1, 1)',
    easeInOut: 'cubic-bezier(0.48, 0, 0.4, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.4, 1)',

    // same as fastOutSlowIn as a fallback
    default: 'cubic-bezier(.4, 0, .2, 1)',
};

export const getTransition = (
    property = 'all',
    {
        duration = ANIMATION_DURATION.default,
        animationCurve = ANIMATION_CURVE.default,
        animationDelay = ANIMATION_DELAY.default,
    }: GetTransitionOptions = {
        duration: ANIMATION_DURATION.default,
        animationCurve: ANIMATION_CURVE.default,
        animationDelay: ANIMATION_DELAY.default,
    }
) => `${property} ${duration}ms ${animationCurve} ${animationDelay}ms`;

export default getTransition;
